<template>
  <div class="stars">
    <button
      v-for="star in [1, 2, 3, 4, 5, 6]"
      :key="star"
      @click="$emit('update:modelValue', star)"
      :class="['stars__star', { 'stars__star--active': modelValue >= star }]"
      type="button"
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 1024 1024"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M742.1 586.8L785.5 839.7C788.5 857.1 776.8 873.6 759.4 876.6L742.1 586.8ZM742.1 586.8L925.8 407.7L742.1 586.8ZM642.093 322.172L645.233 328.539L652.258 329.56L906.116 366.453C906.122 366.454 906.128 366.455 906.135 366.456C916.379 367.988 923.291 377.403 921.758 387.342L921.746 387.416L921.736 387.491C921.164 391.493 919.276 395.189 916.359 398.051C916.356 398.053 916.354 398.056 916.351 398.058L732.676 577.134L727.594 582.088L728.795 589.083L772.195 841.983L772.196 841.994C773.924 852.013 767.192 861.557 757.106 863.296L757.097 863.298L757.087 863.3C753.083 863.996 748.936 863.342 745.443 861.483L745.413 861.467L745.382 861.451L518.282 742.051L512 738.748L505.718 742.051L278.618 861.451L278.607 861.456L278.597 861.462C275.548 863.072 272.109 863.795 268.67 863.55C265.231 863.305 261.93 862.101 259.14 860.075C256.351 858.049 254.185 855.281 252.888 852.087C251.591 848.893 251.215 845.399 251.802 842.001L251.804 841.992L251.805 841.983L295.205 589.083L296.406 582.088L291.324 577.134L107.624 398.034L107.623 398.033C104.103 394.601 102.088 389.912 102.023 384.995C101.958 380.088 103.841 375.355 107.258 371.833C110.119 368.92 113.811 367.036 117.809 366.464L117.825 366.462L117.842 366.46L371.742 329.56L378.767 328.539L381.907 322.172L495.375 92.1374C495.379 92.1283 495.384 92.1191 495.389 92.1099C499.995 82.9338 511.136 79.2187 520.224 83.7053L520.232 83.7092L520.24 83.713C523.866 85.4974 526.803 88.4341 528.587 92.0604L528.593 92.0721L642.093 322.172Z"
          fill="white"
          stroke="#2524e9"
          stroke-width="57"
        />
      </svg>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "Rate",
  props: {
    modelValue: {
      type: Number,
      default: 3,
    },
  },
});
</script>

<style lang="scss" scoped>
.stars {
  @include flex;
  cursor: pointer;

  &__star {
    border: 0 none;
    background-color: transparent;
    cursor: pointer;
    outline: 0 none;
    padding: 0 2px;
    transition: transform 0.1s ease-out;

    &:focus {
      transform: scale(1.2);
    }

    &--active {
      transform: scale(1.2);

      svg path {
        fill: var(--blue-100);
      }

      &:focus {
        transform: scale(1.3);
      }
    }
  }
}
</style>
